<template>
  <textarea
    v-bind:id="id"
    v-bind:value="value"
    v-on:input="onInput($event.target.value)"
    v-bind:placeholder="placeholder"
    v-bind:rows="rows"
    v-on:focus="$emit('focus')"
    v-on:blur="$emit('blur')"
    v-on:keyup="$emit('keyup')"
    v-bind:maxlength="limit"
  />
</template>

<script>
import autosize from 'autosize';

export default {
  name: 'autosize-textarea',

  props: {
    id: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: null,
    },
    limit: {
      type: Number,
      default: undefined,
    },
    rows: {
      type: Number,
      default: 1,
    },
  },

  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
  },

  mounted() {
    autosize(this.$el);
  },
};
</script>
